import { motion } from 'framer-motion';
import { Eye, Wrench, SprayCan, Heart, ShieldCheck } from 'lucide-react';
import { COPY } from '@/lib/data';
import { fadeUp, stagger } from '@/lib/motion';
import { usePublicContent } from '@/lib/usePublicContent';

const ICONS = { Eye, Wrench, SprayCan, Heart };
const ICON_COLORS = ['bg-[hsl(var(--kche-pink))]/15 text-[hsl(var(--kche-pink))]', 'bg-[hsl(var(--kche-blue))]/15 text-[hsl(var(--kche-blue))]', 'bg-[hsl(var(--kche-green))]/15 text-[hsl(var(--kche-green))]', 'bg-[hsl(var(--kche-yellow))]/20 text-[hsl(var(--kche-purple))]'];

export const SafetySection = () => {
    const { content } = usePublicContent();
    const title = content.safety_title || 'Cuidamos a tu familia';
    const body = content.safety_body || 'Trabajamos con protocolos de supervisión, mantenimiento y un ambiente pensado para que cada visita sea segura.';
    return (
        <section data-testid="home-safety" className="relative bg-kche-soft py-16 sm:py-20 lg:py-24">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-start">
                <div>
                    <p className="text-sm font-bold font-display text-[hsl(var(--kche-blue))] uppercase tracking-wider inline-flex items-center gap-2"><ShieldCheck className="size-4" /> Familia y seguridad</p>
                    <h2 className="mt-2 text-3xl sm:text-4xl lg:text-5xl font-display font-bold">{title}</h2>
                    <p className="mt-3 text-muted-foreground text-base sm:text-lg max-w-prose">{body}</p>
                    <p className="mt-3 text-xs text-muted-foreground italic">Texto preliminar, pendiente de confirmación del cliente.</p>
                </div>
                <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.15 }} variants={stagger} className="grid grid-cols-2 gap-4">
                    {COPY.safety.map((c, i) => {
                        const Icon = ICONS[c.icon] || Heart;
                        return (
                            <motion.div key={c.title} variants={fadeUp} className="rounded-2xl bg-white border border-border p-5 shadow-soft hover:shadow-pop transition-all">
                                <span className={`inline-flex size-11 items-center justify-center rounded-2xl ${ICON_COLORS[i % ICON_COLORS.length]}`}><Icon className="size-5" /></span>
                                <h4 className="mt-3 font-display font-bold">{c.title}</h4>
                                <p className="mt-1 text-sm text-muted-foreground">{c.desc}</p>
                            </motion.div>
                        );
                    })}
                </motion.div>
            </div>
        </section>
    );
};

export default SafetySection;
